export default __webpack_public_path__ + "static/media/ISKO CLASS-5 EXAM PATTERN 2026-27.63946fef.pdf";